<template>
  <div :class="['error-500', $i18n.locale]">
    <div class="error-container">
      <h1 @click="goHome">
        <i class="icon icon--logo-horizontal"></i>
      </h1>
      <div class="error-wrap">
        <div class="error-img">
          <asset-error-500 />
        </div>
        <div class="error-text">
          <h2>Error</h2>
          <h3 v-html="$t('error.500.title')"></h3>
          <p v-html="$t('error.500.description')"></p>
          <div class="button">
            <ui-button :primary2="true"
                       :size="'xlarge'"
                       @click="goHome">{{ $t('error.500.button') }}</ui-button>
            <ui-button :size="'xlarge'"
                       class="turn-off"
                       @click="turnOff">{{ $t('common.close') }}</ui-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import { goHome } from '@/libs/utils'

import UiButton from '@/components/ui/UiButton'
import AssetError500 from '@/assets/img/error/500'

export default {
  name: 'Error500',
  components: {
    UiButton,
    AssetError500
  },
  methods: {
    ...mapMutations([
      'setErrorData'
    ]),

    goHome () {
      goHome()
    },

    turnOff () {
      this.setErrorData(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.error-500 {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #F4F4F1;
  overflow: auto;
  z-index: 1000000000000;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);

  .error-container {
    position: relative;
    width: 100%;
    height: 100%;
    min-width: 1120px;
    min-height: 563px;
  }

  h1 {
    position: absolute;
    top: 15px;
    left: 15px;
    cursor: pointer;
  }

  .error-wrap {
    @include positionXYcenter;
    width: 1120px;
    height: 563px;

    .error-text {
      @include positionYcenter;
      padding: 23px 0 0 115px;

      h2 {
        width: 272px;
        height: 78px;
        background: url('../../assets/img/error/asset--error.svg') no-repeat;
        color: transparent;
        margin: 20px 20px 24px 20px;
      }

      h3 {
        font-size: 32px;
        line-height: 1.25;
        color: #00a2c2;
        font-weight: 500;
        margin: 20px;
      }

      p {
        font-size: 14px;
        line-height: 1.71;
        color: #666666;
        margin: 20px;
      }

      .button {
        margin: 25px 20px;

        button {
          padding: 0 20px;
          margin-right: 10px;

          &.turn-off {
            opacity: 0;
            transition: opacity 0.2s ease;

            &:hover {
              opacity: 0.2;
            }
          }
        }
      }
    }

    .error-img {
      @include positionYcenter;
      right: 0;
      margin: -7px -100px;
    }
  }
}
</style>
